import { Field, useFormState } from 'react-final-form';
import { RenderIf } from 'react-rainbow-components';
import CallScriptPicker from 'components/CallScriptPicker';
import CallResponderPicker from 'components/CallResponderPicker';
import { validateNotEmpty } from 'data/validators';
import { FieldsContainer, Hint } from './styled';
import { FormValues } from './types';
import CallerPicker from './CallerPicker';
import PhonePicker from './PhonePicker';

const Fields = ({ agentId }: { agentId: string }) => {
    const { values } = useFormState<FormValues>();
    return (
        <FieldsContainer>
            <Field
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                component={CallerPicker}
                name="caller"
                label="Who should make this call?"
                labelAlignment="left"
                borderRadius="semi-rounded"
            />
            <RenderIf isTrue={values?.caller === 'sara'}>
                <Field
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    component={CallScriptPicker}
                    name="callScript"
                    label="What's the Call About?"
                    placeholder="Select the purpose"
                    labelAlignment="left"
                    borderRadius="semi-rounded"
                    validate={validateNotEmpty('This field is required')}
                    agentId={agentId}
                />
                <Hint>
                    Choose the purpose of the call so Sara AI can
                    follow the right instructions, like confirming appointments.
                </Hint>
                <Field
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    component={CallResponderPicker}
                    name="voicemailScript"
                    label="Do you want Sara to leave a Voice Mail?"
                    placeholder="Select the voicemail script"
                    formatStyle="medium"
                    labelAlignment="left"
                    borderRadius="semi-rounded"
                    agentId={agentId}
                />
                <Hint>
                    Choose the instructions for Sara AI to follow in case
                    the customer doesn&apos;t answer. This will help Sara AI
                    leave a voicemail with the right information.
                </Hint>
            </RenderIf>
            <RenderIf isTrue={values?.caller !== 'sara'}>
                <Field
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    component={PhonePicker}
                    name="phoneNumber"
                    label="Select Phone Number:"
                    formatStyle="medium"
                    labelAlignment="left"
                    placeholder="Select Phone Number"
                    borderRadius="semi-rounded"
                    validate={validateNotEmpty('This field is required')}
                    agentId={agentId}
                />
                <Hint>
                    We will call this number first. When you answer, we&apos;ll
                    connect you with the customer.
                </Hint>
            </RenderIf>
        </FieldsContainer>
    );
};

export default Fields;
